import { render, staticRenderFns } from "./Acknowledgement.vue?vue&type=template&id=71486c88&"
import script from "./Acknowledgement.vue?vue&type=script&lang=js&"
export * from "./Acknowledgement.vue?vue&type=script&lang=js&"
import style0 from "./Acknowledgement.vue?vue&type=style&index=0&id=71486c88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports